import React from 'react';
import MainContent from '../../components/mainContent/MainContent';
import { JustificacionBloqueo } from './components/JustificacionBloqueo';

export default function Justificacion() {
  return (
    <>
      <MainContent
        titulo='Datos Justificación'
        component={<JustificacionBloqueo />}
        tableMaxWidth
      />
    </>
  );
}